

















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import CreateAgencyUserRequest from '@/models/AgencyUsers/CreateAgencyUserRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BranchDto from '@/models/Branches/BranchDto';

@Component({
    name: 'AgencyUserCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new AgencyUserDto();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new AgencyUserDto();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get desks() {
    if (this.entity.defaultBranch) {
      return this.entity.defaultBranch.desks;
    }
    return [];
  }

  get branches() {
      return AgencySettingsModule.branches;
  }

  @Watch('entity.defaultBranch')
  onDefaultBranchChanged(val: BranchDto, oldVal: BranchDto) {
    if (!val) {
      this.entity.defaultDeskId = undefined;
      this.entity.defaultDesk = undefined;
    }
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateAgencyUserRequest();
    request.firstName = this.entity.person.firstName;
    request.lastName = this.entity.person.lastName;
    request.emailAddress = this.entity.emailAddress;
    request.mobilePhoneNumber = this.entity.mobilePhoneNumber;
    request.otherPhoneNumber = this.entity.otherPhoneNumber;
    if (this.entity.defaultBranch) {
      request.defaultBranchId = this.entity.defaultBranch.id;
    }
    if (this.entity.defaultDesk) {
      request.defaultDeskId = this.entity.defaultDesk.id;
    }
    request.isAdministrator = this.entity.isAdministrator;
    await AgencySettingsModule.createAgencyUser(request);
    this.dialog = false;
  }
}
